import entityReducer from "./propertyEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
